// TODO - remove becouse of legacy

export const SAVE_AD_SPENDS = 'adSpends/SAVE_AD_SPENDS'
export const FETCH_AD_SPENDS = 'adSpends/FETCH_AD_SPENDS'
export const FETCH_AD_SPENDS_REPORT = 'adSpends/FETCH_AD_SPENDS_REPORT'
export const CHANGE_DATE_LIST = 'adSpends/CHANGE_DATE_LIST'
export const CHANGE_DATES_RANGE_REPORT = 'adSpends/CHANGE_DATES_RANGE_REPORT'
